var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleRemove = function SvgCircleRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 36"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "circle-remove_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h36v36H.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-remove_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E60021",
    d: "M18.5 33c8.284 0 15-6.716 15-15s-6.716-15-15-15-15 6.716-15 15 6.716 15 15 15"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "circle-remove_svg__b",
    width: 37,
    height: 36,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.5 0H.5v36h36z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#circle-remove_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m17.44 18.107-4.774 4.773 1.415 1.414 4.773-4.773 4.419 4.42 1.414-1.415-4.42-4.42 4.42-4.419-1.414-1.414-4.42 4.42-4.772-4.774-1.415 1.415z",
    clipRule: "evenodd"
  })))));
};
export { SvgCircleRemove as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzcgMzYiIGZpbGw9Im5vbmUiCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMl8zMjQyIj4KICAgICAgPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41KSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzJfMzI0MikiPgogICAgPHBhdGggZD0iTTE4LjUgMzNDMjYuNzg0MyAzMyAzMy41IDI2LjI4NDMgMzMuNSAxOEMzMy41IDkuNzE1NzMgMjYuNzg0MyAzIDE4LjUgM0MxMC4yMTU3IDMgMy41IDkuNzE1NzMgMy41IDE4QzMuNSAyNi4yODQzIDEwLjIxNTcgMzMgMTguNSAzM1oiIGZpbGw9IiNFNjAwMjEiLz4KICAgIDxtYXNrIGlkPSJtYXNrMF8yXzMyNDIiIHN0eWxlPSJtYXNrLXR5cGU6bHVtaW5hbmNlIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzciIGhlaWdodD0iMzYiPgogICAgICA8cGF0aCBkPSJNMzYuNSAwSDAuNVYzNkgzNi41VjBaIiBmaWxsPSJ3aGl0ZSIvPgogICAgPC9tYXNrPgogICAgPGcgbWFzaz0idXJsKCNtYXNrMF8yXzMyNDIpIj4KICAgICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy40MzkzIDE4LjEwNjZMMTIuNjY2NCAyMi44Nzk2TDE0LjA4MDYgMjQuMjkzOEwxOC44NTM2IDE5LjUyMDhMMjMuMjczIDIzLjk0MDJMMjQuNjg3MiAyMi41MjZMMjAuMjY3OCAxOC4xMDY2TDI0LjY4NzIgMTMuNjg3MkwyMy4yNzMgMTIuMjczTDE4Ljg1MzYgMTYuNjkyNEwxNC4wODA2IDExLjkxOTRMMTIuNjY2NCAxMy4zMzM2TDE3LjQzOTMgMTguMTA2NloiIGZpbGw9IndoaXRlIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4=";